import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useLegacyMode } from '@/entities/legacy-mode';
import { LegacyOperatingPage } from '@/pages/legacy-operating';
import { requireAuth } from '../require-auth';

/**
 * Правила эксплуатации — LEGACY ONLY.
 *
 * Reached from the dashboard's operating card. No new-design counterpart, so
 * with legacy mode off it redirects rather than showing a legacy screen to
 * someone who never opted in.
 */
export const Route = createFileRoute('/delivery/operating')({
  beforeLoad: requireAuth,
  component: DeliveryOperatingRoute,
});

function DeliveryOperatingRoute() {
  const legacy = useLegacyMode();
  if (!legacy) return <Navigate to="/delivery" />;
  return <LegacyOperatingPage />;
}
